<template>
 <section class="hero">
    <div class="hero-body">
      <div class="container">
        <h1 class="title">
                Lingue
        </h1>
        <b-tabs v-model="selectedTab">
            <b-tab-item label="Tabella">
              <div style="cursor:pointer">
              <b-table :data="rowData" :columns="columns"
                  :striped=true
                  :paginated="true"
                  :per-page="15"
                  :pagination-simple="false"
                  :selected.sync="selected"
                  @select="select"
                  @click="rowClicked"
                  >
                <b-input
                  slot="searchable"
                  slot-scope="props"
                  v-model="props.filters[props.column.field]"
                  placeholder="Cerca..."
                  icon="magnify"
                  size="is-small" 
                />
              </b-table>
              </div>
               <section>
                  <div class="buttons">
                    <b-button @click="doNew" type="is-primary" >Nuovo</b-button>
                  </div>
                </section>
            </b-tab-item>

            <b-tab-item label="Azioni">
            <div class="column is-half" ref="form">
              
                <section >
                  <span v-if="newItem.Id" class="subtitle">Id: {{newItem.Id}}</span>
                <b-field label="Lingua">
                   <b-input ref="input1" v-model="newItem.Language" required validation-message="Scrivi qualcosa!" ></b-input>
                </b-field>   
                
                <div class="field">
                  <b-checkbox v-model="newItem.Active">Attivo</b-checkbox>
                </div>
                </section>
                <section>
                  <div class="buttons">
                    <b-button @click="doEdit" type="is-primary" >Salva</b-button>
                    <b-button @click="doDelete" v-show="newItem.Id!=0" type="is-dark">Scancella</b-button>
                  </div>
                </section>
              </div>
            </b-tab-item>
          </b-tabs>
      </div>
    </div>
  </section>
</template>

<script>
import api from "../api/api.js";
import helpers from "../helpers.js";

let emptyVal = {Id: 0, Language:"" , Active:true};

export default {
  name: 'language',
  methods: {
    doDelete() {
      this.$buefy.dialog.confirm({
        message: 'Lo scancello sul serio?',
        onConfirm: () => {
          const loading = this.$buefy.loading.open()
          api.language.delete(this.newItem.Id) 
            .then (()=>{
              return api.language.getAll()
            })
            .then ((rows)=>{
              this.rowData = rows.data;
              helpers.ok('Lingua correttamente scancellata');
              this.newItem = emptyVal;
              this.selectedTab = 0;
              loading.close();
            })
            .catch ((err)=> {
              helpers.error("Errore! " + err)
              loading.close();
            })
        }
    })
    },
    doNew() {
      this.newItem = emptyVal;
      this.selectedTab = 1;
    },
    doEdit() {
      if(!this.$refs["input1"].checkHtml5Validity()) {
        return;
      }
      let apiMethod = this.newItem.Id!=0?api.language.update:api.language.create;
      const loading = this.$buefy.loading.open()
      apiMethod(this.newItem)
      .then (()=>{
        return api.language.getAll()
      })
      .then ((rows)=>{
          this.rowData = rows.data;
          helpers.ok('Lingua correttamente salvata');
          this.newItem = emptyVal;
          this.selectedTab = 0;
          loading.close();
      })
      .catch ((err)=> {
        helpers.error("Errore! " + err)
        loading.close();
      })
      
    },
    rowClicked(row) {
      if (row.Id==this.newItem.Id) {
         this.selected = null;
         this.newItem = emptyVal;
       }else {
         this.selectedTab=1;
       }
        
    },
    select(row) {
       this.newItem = row;
    }    
  },
  data() {
        return {
            selectedRow: null,
            newItem: emptyVal,
            rowData: [],
            selected: null,
            selectedTab: 0,
            columns: [
                {
                    field: 'Id',
                    label: 'id',
                    width: '40',
                    numeric: true
                },
                {
                    field: 'Language',
                    label: 'Lingua',searchable: true,
                    sortable: true
                },
                {
                    field: 'Active',
                    label: 'Attivo',
                }
            ]
        }
    },
    mounted() {
       const loading = this.$buefy.loading.open()
        api.language.getAll()
        .then ((rows)=>{
          this.rowData = rows.data;
          this.$store.state.languages = rows.data;
          loading.close();
        })
    }
}
</script>

<style>

</style>